export const VSS_EVENTS = {
    // 供货规则切换事件
    VSS_HEADER_SUPPLIER_CHANGE: 'supplierIdChange',
    // 供应商选择器属性
    VSS_HEADER_SUPPLIER_SELECT: 'supplierSelect',
};

export const STEP_MAP = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
};

export const STEP_LIST = [
    { value: STEP_MAP.ZERO, label: '基本信息' },
    { value: STEP_MAP.ONE, label: '供货信息' },
    { value: STEP_MAP.TWO, label: '综合能力' },
    { value: STEP_MAP.THREE, label: '其他信息' },
];


export const AJAX_ACTION = `${window.location.origin}/api/upload/picture.ajax`;


// source："来源：1.采购推荐 2.线下活动 3.线索 4.商家自主提报 5.未知"
// entryPoint："填写入口：1.美团app 2.小象app 3.二维码 4.vsspc、 5.微信小程序 、6.小象超市官网、7.未知（历史数据）、8.芥末"
// eventName：活动名称
// eventDate：活动日期
export const SOURCE_TYPE = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
};
export const ENTRY_POINT = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8,
};

export function isValidSource(source) {
    return Object.values(SOURCE_TYPE).includes(Number(source));
}
export function isValidEntryPoint(entryPoint) {
    return Object.values(ENTRY_POINT).includes(Number(entryPoint));
}
export function saveSourceParamsToLocalStorage(
    source = '',
    entryPoint = '',
    eventName = '',
    eventDate = '',
) {
    const obj = {
        source: isValidSource(source) ? source : '',
        entryPoint: isValidEntryPoint(entryPoint) ? entryPoint : '',
        eventName: eventName ? decodeURIComponent(eventName) : '',
        eventDate,
    };
    // 将来源参数保存到localStorage
    if (obj.source || obj.entryPoint || obj.eventName || obj.eventDate) {
        localStorage.setItem('sourceParams', JSON.stringify(obj));
    }
}
export function getSourceParamsFromLocalStorage() {
    const params = localStorage.getItem('sourceParams');
    if (!params) return {};

    const {
        source, entryPoint, eventName, eventDate,
    } = JSON.parse(params);
    return {
        source: isValidSource(source) ? source : '',
        entryPoint: isValidEntryPoint(entryPoint) ? entryPoint : '',
        eventName,
        eventDate,
    };
}
export function clearSourceParams() {
    localStorage.removeItem('sourceParams');
}

// 申请流程
export const introductionSteps = [
    {
        title: '申请',
        icon: 'https://p1.meituan.net/mallimages/9ef77adba1203c7e6a094cd0453ac6e97156.png',
        description: '请重点展示在<span style="color:#01A65C;font-weight:600;">供货能力、范围以及合作商品</span>方面的优势，尤其是商品的<span style="color:#01A65C;font-weight:600;">价格信息</span>。这将帮助您在众多候选商家中脱颖而出。',
    },
    {
        title: '候选',
        icon: 'https://p0.meituan.net/mallimages/1bcdc63e58a5696bd6fdb1b0a85793a17510.png',
        description: '我们将在<span style="color:#01A65C;font-weight:600;">1～7个工作日</span>内完成人工选商，若入选，将有对接人主动联系。',
    },
    {
        title: '洽谈',
        icon: 'https://p0.meituan.net/mallimages/82335cac40a4a861e7801de97543668f6732.png',
        description: '成功入选后，我们将在<span style="color:#01A65C;font-weight:600;">1～3个工作日</span>内联系您，完成信息核实和合作洽谈。',
    },
    {
        title: '准入',
        icon: 'https://p0.meituan.net/mallimages/7bf3ad100050b5b2d0df5e9b2af534a17281.png',
        description: '确认合作细节后，我们将在<span style="color:#01A65C;font-weight:600;">1～3个工作日</span>内完成准入审批流程。',
    },
];

// 常见问题
export const quesitons = [
    {
        title: '小象超市的合作范围是什么？',
        description: '我们欢迎生鲜、餐饮熟食、快消品、家居服饰等各类商家入驻，暂不接受个体户的合作申请，敬请见谅。',
    },
    {
        title: '在申报中遇到问题怎么办？',
        description: '请邮件发送至<span style="color: #01A65C;font-weight: 600;">mtmc.gysfw@meituan.com</span><br/>将您遇到的问题描述、页面截图、公司名称和联系方式发送给我们，我们将协助解决。',
    },
];

export const exampleTaxImg = 'https://p0.meituan.net/mallimages/705e08719e88e1a12399ffd1805233eb3243870.png';
